/* Run 09 — PDP v2 helpers. The buy box itself is radiancy-tc.js initHero (unchanged). This file adds:
   - the "Save an extra 25% with automatic refills" row, which drives initHero's hidden one-time/subscribe buttons;
   - hiding a "SAVE $0.00" pill, and locking gifts that need a bigger pack (free shipping = 2+ bottles);
   - the "offer ends soon" countdown (to local midnight, same clock as the announcement bar);
   - "pick pack N" buttons further down the page;
   - a page-scoped UpCart mute so the drawer never flashes between /cart/add.js and the /checkout redirect.
   The add-to-cart request stays on the main window's fetch (Shopify → Meta AddToCart). */
(function () {
  if (window.__pdp2Boot) return;
  window.__pdp2Boot = true;

  function hero() { return document.querySelector(".pdp2-hero[data-tc-kind='hero']"); }

  function sync(subscribe) {
    var root = hero();
    if (!root) return;
    var row = root.querySelector("[data-pdp2-subrow]");
    if (row) {
      row.classList.toggle("is-on", !!subscribe);
      row.setAttribute("aria-pressed", subscribe ? "true" : "false");
    }
    root.querySelectorAll("[data-tc-pack-save]").forEach(function (el) {
      el.hidden = /\$0\.00$/.test(el.textContent.trim());
    });
    var sel = root.querySelector("[data-tc-pack].is-selected");
    var n = Number(sel ? sel.getAttribute("data-pdp2-pack") : 1) || 1;
    root.querySelectorAll("[data-pdp2-gift-min]").forEach(function (g) {
      g.classList.toggle("is-locked", n < Number(g.getAttribute("data-pdp2-gift-min") || 1));
    });
  }
  document.addEventListener("tc:offer-change", function (e) {
    sync(!!(e.detail && e.detail.subscribe));
  });
  function firstSync() { if (window.__tcOffer) sync(!!window.__tcOffer.subscribe); }
  firstSync();
  document.addEventListener("DOMContentLoaded", firstSync);

  document.addEventListener("click", function (e) {
    var row = e.target && e.target.closest && e.target.closest("[data-pdp2-subrow]");
    if (!row) return;
    e.preventDefault();
    var root = hero();
    if (!root) return;
    var on = !!(window.__tcOffer && window.__tcOffer.subscribe);
    var btn = root.querySelector(on ? "[data-tc-onetime]" : "[data-tc-sub-toggle]");
    if (btn) btn.click();
  });

  function pad(n) { return String(n).padStart(2, "0"); }
  function tick() {
    var now = new Date();
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var txt = pad(Math.floor(s / 3600)) + ":" + pad(Math.floor(s / 60) % 60) + ":" + pad(s % 60);
    document.querySelectorAll("[data-pdp2-countdown]").forEach(function (el) { el.textContent = txt; });
  }
  tick();
  setInterval(tick, 1000);

  function muteUpCart() {
    try {
      var s = window.upcartSettings && window.upcartSettings.upcartSettings;
      if (s) s.openOnAddToCart = false;
    } catch (e) { /* app not present */ }
  }
  muteUpCart();
  [500, 1500, 3500, 7000].forEach(function (ms) { setTimeout(muteUpCart, ms); });
  document.addEventListener("click", function (e) {
    var atc = e.target && e.target.closest && e.target.closest(".pdp2-hero [data-tc-atc]");
    if (!atc) return;
    muteUpCart();
    document.documentElement.classList.add("pdp2-going");
  }, true);
  window.addEventListener("pageshow", function () {
    document.documentElement.classList.remove("pdp2-going");
  });

  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest && e.target.closest("[data-pdp2-pick]");
    if (!btn) return;
    e.preventDefault();
    var root = hero();
    if (!root) return;
    var pack = root.querySelector('[data-pdp2-pack="' + btn.getAttribute("data-pdp2-pick") + '"]');
    if (pack) pack.click();
    var target = document.getElementById("pack-selector") || root;
    var y = target.getBoundingClientRect().top + window.pageYOffset - 150;
    window.scrollTo({ top: y, behavior: "smooth" });
  });
})();
